import { gql } from '../../__generated__/gql'

export const UNFOLLOW_CATEGORY_MUTATION = gql(`
  mutation communityUnfollowCategory($categoryId: Int!) {
    communityUnfollowCategory(input: {categoryId: $categoryId}) {
      user {
        id
        communityProfile {
          followCategories {
            id
            title
          }
        }
      }
    }
  }
`)
